import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

export interface UseEnduserChatRoomsOptions {
  limit?: number;
  /** Whether to enable the query (defaults to true) */
  enabled?: boolean;
}

export function useEnduserChatRooms(options: UseEnduserChatRoomsOptions = {}) {
  const { limit = 50, enabled = true } = options;

  const query = useTellescopeInfiniteQuery({
    model: "chat_rooms",
    method: "getSome",
    request: {
      filter: {},
      limit,
    },
    select: (data) => data.pages.flat(),
    enabled,
  });

  const allChatRooms = query.data ?? [];

  // Sort by most recent message (recentMessageSentAt) or updatedAt
  const sortedChatRooms = [...allChatRooms].sort((a, b) => {
    const aTime = a.recentMessageSentAt ?? new Date(a.updatedAt).getTime();
    const bTime = b.recentMessageSentAt ?? new Date(b.updatedAt).getTime();
    return bTime - aTime;
  });

  return {
    ...query,
    chatRooms: sortedChatRooms,
  };
}
